import {FC, useState} from 'react';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {useForm} from 'react-hook-form';
import {toast} from 'react-toastify';

import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {Box, Modal, Stack, Typography} from '@mui/material';
import ControlledInput from '../../ui/controlled-input/ControlledInput';

import {UserAccountService} from '../../api/services/user-account.service';

import {passwordRegExp} from '../../shared/validation/passwordRegExp';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  width: 320,
  p: 2,
};

interface ISetPassword {
  open: boolean;
  handleClose: () => void;
}

export const SetPassword: FC<ISetPassword> = ({open, handleClose}) => {
  // const currentUserId = useRecoilValue(currentUserAccountIdState)
  // const triggerUsersQuery = useSetRecoilState(userAccountsQueryTrigger)
  const {
    control,
    getValues,
    trigger,
    reset,
    watch,
    formState: {errors},
  } = useForm({mode: 'onChange'});
  const [loading, setLoading] = useState(false);

  const password = watch('password');
  const checkedPassword = watch('checkedPassword');

  const onSetPassword = async () => {
    setLoading(true);
    const start = Date.now();
    // try {
    //     formData.append('password', data.password)
    //     formData.append('checkedPassword', data.checkedPassword)

    //     await UserAccountService.changePassword(currentUserId), formData)

    //     toast.success('Пароль изменен', {
    //         autoClose: 2000,
    //         hideProgressBar: true,
    //         pauseOnHover: false,
    //         draggable: false,
    //     })

    //     setTimeout(() => {
    //         setLoading(false)
    //         triggerUsersQuery(v => v + 1)
    //         handleClose()
    //         reset()
    //     }, 1000)
    // }
    // catch (err: any) {
    //     console.error(err)

    //     toast.error(err.message, {
    //         autoClose: 2000,
    //         hideProgressBar: true,
    //         pauseOnHover: true,
    //         draggable: false,
    //     })

    //     setLoading(false)
    // }

    setTimeout(() => {
      setLoading(false);
      handleClose();
      toast.success('Пароль установлен', {
        containerId: 'default',
        autoClose: 2000,
        hideProgressBar: true,
        pauseOnHover: false,
        draggable: false,
      });
    }, 2000);
  };

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Stack direction="column" spacing={1.5}>
          <Stack direction="row" sx={{justifyContent: 'center'}}>
            <Typography variant="h6">Установите пароль</Typography>
          </Stack>
          <Stack direction="column" spacing={0.25}>
            <ControlledInput
              name="password"
              control={control}
              type="password"
              label="Пароль"
              size="small"
              rules={{
                required: true,
                pattern: {
                  value: passwordRegExp,
                  message:
                    'От 12 символов с использованием цифр, спец. символов, латиницы, наличием строчных и прописных символов',
                },
              }}
            />
          </Stack>
          <Stack>
            <ControlledInput
              name="checkedPassword"
              type="password"
              label="Повторите пароль"
              control={control}
              size="small"
              rules={{
                required: true,
                validate: {
                  isTheSame: (v, values) => {
                    return values.password === v ? true : 'Пароли не совпадают';
                  },
                },
              }}
            />
          </Stack>
          <Stack direction="column"></Stack>
          <Stack direction="row" sx={{width: '100%'}}>
            <LoadingButton
              sx={{width: '100%'}}
              variant="contained"
              onClick={() => {
                trigger().then((bool) => {
                  bool && onSetPassword();
                });
              }}
              loading={loading}
              disabled={!password || !checkedPassword || !!errors.password || !!errors.checkedPassword}
            >
              Готово
            </LoadingButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
